import { render } from "./TractorCreateEditDialog.vue?vue&type=template&id=c2652584&scoped=true&ts=true"
import script from "./TractorCreateEditDialog.vue?vue&type=script&lang=ts"
export * from "./TractorCreateEditDialog.vue?vue&type=script&lang=ts"

import "./TractorCreateEditDialog.vue?vue&type=style&index=0&id=c2652584&scoped=true&lang=css"

import exportComponent from "C:\\BuildAgent\\work\\330398ee0e098db7\\LoadingSokoldok\\Loading\\loading_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2652584"]])

export default __exports__